import 'css-chunksrc/client/scenes/optimizedGantt/header/creationMenu/styles.scss';export default {
  "creationMenu": "_creationMenu_2c11x_1",
  "button": "_button_2c11x_5",
  "icon": "_icon_2c11x_25",
  "iconBox": "_iconBox_2c11x_33",
  "menu": "_menu_2c11x_42",
  "menuItem": "_menuItem_2c11x_54",
  "menuText": "_menuText_2c11x_67"
};